module.exports = __webpack_public_path__ + "img/img2.31b3f8c9.png";